import { useState } from "react";
import { useHistory } from "react-router-dom";
import { useDispatch } from "react-redux";
import { executeGetColumnOrderInfo } from "src/utils/utils";
import { updateColumnReorderAsync } from "src/lib/common-service";

const useColumnReorder = (
  cookiesData,
  setColumnsData,
  module = "",
  role = "",
  originalColumns,
  setLoadingState = () => {},
  parentModule = ""
) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const prepareColumnString = (colData) => {
    return executeGetColumnOrderInfo(colData, module);
  };

  const columnReorderData = async (columnData) => {
    const str = prepareColumnString(columnData.filter((x) => parentModule === "audit-log" || x.field !== "action"));

    setLoadingState((prevState) => ({
      ...prevState,
      updateColumn: true,
    }));

    const reqData = {
      in_db_name: role,
      in_tenant_id: cookiesData.out_tenant_id,
      in_filter_logical_cond: "N",
      in_filter_label_cond: "N",
      in_column_info: str,
    };

    try {
      const res = await updateColumnReorderAsync(reqData, dispatch, history);
      if (res) {
        setColumnsData([]);
        const colDataList = JSON.parse(JSON.stringify(columnData));
        colDataList.forEach((item) => {
          item.hidden = false;
        });

        const sortedColData = colDataList.sort((a, b) => a.ariaColumnIndex - b.ariaColumnIndex);

        const originalColumnsARRAY = originalColumns.filter((col) => col.title !== "").map((col) => ({ ...col }));

        originalColumnsARRAY.forEach((col, index) => {
          col.ariaColumnIndex = index + 1;
        });
        const sortedFields = sortedColData.map((item) => item.field);
        const sortedFieldsSet = new Set(sortedFields);

        // 1. Create a lookup map from originalColumnsARRAY
        const originalMap = new Map(originalColumnsARRAY.map((item) => [item.field, item]));

        // 2. Build the base result with sortedColData, enriched from originalColumnsARRAY
        const baseArray = sortedColData.map((sortedItem) => {
          const originalItem = originalMap.get(sortedItem.field);
          return {
            ...originalItem,
            show: sortedItem.show, // carry over "show" from sortedColData
          };
        });

        // 3. Now insert missing items from originalColumnsARRAY in their original positions
        const finalArray = [...baseArray];
        originalColumnsARRAY.forEach((item, index) => {
          if (!sortedFieldsSet.has(item.field)) {
            finalArray.splice(index, 0, {
              ...item,
              show: false,
            });
          }
        });
        setColumnsData(finalArray);
      }
    } catch (error) {
      console.error("Column reordering failed:", error);
    } finally {
      setLoadingState((prevState) => ({
        ...prevState,
        updateColumn: false,
      }));
    }
  };

  return {
    columnReorderData,
  };
};

export default useColumnReorder;
